import type { Catalog } from '..'

export const shell: Catalog['shell'] = {
  account: 'Conta',
  teamPlan: 'Plano Team',
  personalPlan: 'Plano pessoal',
  settings: 'Configurações',
  admin: 'Admin',
  helpDocs: 'Ajuda e documentação',
  desktopApp: 'Baixar o app para desktop',
  website: 'Site do Doop',
  appearance: 'Aparência',
  language: 'Idioma',
  logOut: 'Sair',
}
